import PropTypes from 'prop-types';

import moment from 'moment';

/* Custom react prop validators */

function _setValidator(isRequired, props, propName) {
  const passedProp = props[propName];
  if (passedProp) {
    return passedProp instanceof Set
      ? null
      : new Error(`Expected ${propName} to be a Set`);
  } else if (isRequired) {
    return new Error(`${propName} is a required prop`);
  }
  return null;
}

export const setValidator = _setValidator.bind(null, false);
setValidator.isRequired = _setValidator.bind(null, true);

function _mapValidator(isRequired, props, propName) {
  const passedProp = props[propName];
  if (passedProp) {
    return passedProp instanceof Map
      ? null
      : new Error(`Expected ${propName} to be a Map`);
  } else if (isRequired) {
    return new Error(`${propName} is a required prop`);
  }
  return null;
}

export const mapValidator = _mapValidator.bind(null, false);
mapValidator.isRequired = _mapValidator.bind(null, true);

function _momentValidator(isRequired, props, propName) {
  const passedProp = props[propName];
  if (passedProp) {
    return passedProp instanceof moment
      ? null
      : new Error(`Expected ${propName} to be a MomentJS object`);
  } else if (isRequired) {
    return new Error(`${propName} is a required prop`);
  }
  return null;
}

export const momentValidator = _momentValidator.bind(null, false);
momentValidator.isRequired = _momentValidator.bind(null, true);

export const arrayOfTypes = (typeCheckers) => {
  return PropTypes.arrayOf((value, index, ...rest) => {
    return typeCheckers[index].call(PropTypes, value, index, ...rest);
  });
};
